module.exports = "/src/views/player/help/images/lsc.jpg";